import { Fragment, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { SiteHeader } from "@/components/header";
import Footer from "@/components/footer/footer";
import ScrollToTop from "@/components/scroll-to-top";
import FloatingContact from "@/components/floating-contact/FloatingContact";
import PageBanner from "@/components/pageBanner";
import { ToastContainer } from "react-toastify";
import { Nunito_Sans,Poppins } from "next/font/google";
import { fetchGlobalSettings } from "@/lib/globalSettings";

export const nunito = Nunito_Sans({
  weight: ["200", "300", "400", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

export const Poppin = Poppins({
  weight: ["200", "300", "400", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const DEFAULT_TITLE_BY_PATH = {
  "/about": "About Us",
  "/projects": "Our Projects",
  "/projects/[slug]": "",
  "/blog": "Blog",
  "/blog/[slug]": "Blog Post",
  "/category/[slug]": "Category",
  "/tag/[slug]": "Tag",
  "/contact": "Contact",
  "/404": "Page Not Found",
};

// Per-page banner image. Home (/) is excluded — it has its own hero.
const DEFAULT_BANNER_BY_PATH = {
  "/about":"/img/banner/about-banner.webp",
  "/projects": "/img/banner/project-banner.webp",
  "/projects/[slug]": "/img/banner/project-banner.webp",
  "/blog": "/img/banner/blog-banner.webp",
  "/category/[slug]": "/img/banner/blog-banner.webp",
  "/tag/[slug]": "/img/banner/blog-banner.webp",
"/contact": "/img/banner/contact-banner.webp",
  "/404": "/img/product-3/6.webp",
};

const FALLBACK_BANNER = "/img/banner/project-banner.webp";

const parseJsonMap = (raw, fallback) => {
  if (!raw || typeof raw !== "string") return fallback;
  try {
    const v = JSON.parse(raw);
    return v && typeof v === "object" ? v : fallback;
  } catch {
    return fallback;
  }
};

const resolveTitle = (router, titleByPath) => {
  if (!router || !router.pathname) return "Page";
  if (titleByPath[router.pathname] !== undefined) return titleByPath[router.pathname];
  const base = "/" + (router.pathname.split("/")[1] || "");
  return titleByPath[base] !== undefined ? titleByPath[base] : "Page";
};

const resolveBanner = (router, bannerByPath) => {
  if (!router || !router.pathname) return FALLBACK_BANNER;
  if (bannerByPath[router.pathname]) return bannerByPath[router.pathname];
  const base = "/" + (router.pathname.split("/")[1] || "");
  return bannerByPath[base] || FALLBACK_BANNER;
};

const LayoutOne = ({ children, navPositionClass, topbar, banner = true, showHeading = true, recentBlogs, bannerImage, bannerTitle }) => {
  const [toggleClassName, SetToggleClassName] = useState(false);
  const [titleByPath, setTitleByPath] = useState(DEFAULT_TITLE_BY_PATH);
  const [bannerByPath, setBannerByPath] = useState(DEFAULT_BANNER_BY_PATH);
  const router = useRouter();

  useEffect(() => {
    let alive = true;
    fetchGlobalSettings().then((s) => {
      if (!alive || !s) return;
      setTitleByPath(parseJsonMap(s.layout_title_overrides, DEFAULT_TITLE_BY_PATH));
      setBannerByPath(parseJsonMap(s.layout_banner_overrides, DEFAULT_BANNER_BY_PATH));
    });
    return () => { alive = false; };
  }, []);

  function toggleClassNameInBody() {
    SetToggleClassName((toggleClassName) => !toggleClassName);
  }

  const resolvedTitle = resolveTitle(router, titleByPath);
  const title = bannerTitle || resolvedTitle;
  const image = bannerImage || resolveBanner(router, bannerByPath);

  return (
    <Fragment>

      <style jsx global>{`
        html,body {
          font-family: ${nunito.style.fontFamily};
        }

        h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {

          font-family: ${Poppin.style.fontFamily};
      }


      `}</style>
       <ToastContainer />
      <div
        className={`body-wrapper ${toggleClassName ? "ltn__utilize-open" : ""}`}
      >
        <SiteHeader topbar={topbar} />
        {banner ? (
          <PageBanner title={title} image={image} />
        ) : null}
        {showHeading && title && title !== "Page" && title !== "" ? (
          <div className="page-heading-wrap">
            <h1 className="page-heading">{title}</h1>
          </div>
        ) : null}
        {children ? (
          <main id="main-content" role="main" tabIndex={-1}>
            {children}
          </main>
        ) : null}
        <Footer recentBlogs={recentBlogs} />
        <FloatingContact />
        <ScrollToTop />
      </div>
    </Fragment>
  );
};

export default LayoutOne;
